import { useCallback, useMemo } from 'react';
import { Pressable } from 'react-native';
import {
  Box,
  formatMoney,
  Icon,
  Skeleton,
  Text,
  useStyle,
} from '@betty/moonlight';
import { useFocusEffect, useNavigation } from '@betty/navigation';
import {
  selectBonusBalance,
  selectCashBalance,
  selectCashBalanceDataState,
} from '../../state/cashBalance/cashBalance.slice';
import { useSelector, useDispatch } from '@betty/toolkit/state';
import { getCashBalance } from '../../state/cashBalance/cashBalance.slice';

const staticStyles = {
  height: 40,
  variant: 'default',
  width: 'auto',
  backgroundColor: 'secondaryBackgroundDefault',
  borderRadius: 'radius-200',
  padding: 'space-300',
  gap: 'space-100',
  flexDirection: 'column',
  justifyContent: 'center',
} as const;

function CashBalanceHeaderItem({
  disableNavigation,
}: {
  disableNavigation?: boolean;
}) {
  const dispatch = useDispatch();
  const navigation = useNavigation();
  const pressableStyle = useStyle({ ...staticStyles });
  const cashBalance = useSelector(selectCashBalance);
  const bonusBalance = useSelector(selectBonusBalance);
  const totalCashBalance = cashBalance + bonusBalance;
  const cashBalanceDataState = useSelector(selectCashBalanceDataState);

  const onPress = useCallback(() => {
    navigation.navigate('MainTabNavigator', { screen: 'Account' });
  }, [navigation]);

  const cash = useMemo(
    () =>
      cashBalanceDataState?.match('fulfilled|refreshing') ? (
        formatMoney(totalCashBalance)
      ) : (
        <Skeleton width={70} height={20} />
      ),
    [cashBalanceDataState, totalCashBalance],
  );

  useFocusEffect(
    useCallback(() => {
      dispatch(getCashBalance());
    }, [dispatch]),
  );

  return (
    <Pressable
      style={pressableStyle}
      onPress={disableNavigation ? undefined : onPress}
    >
      <Box flexDirection="row" alignItems="center" gap="space-200">
        <Icon name="bettyWallet" color="darkSurfaceAccentSolid" />
        <Text
          variant="caption"
          color={'darkSurfacePrimary'}
          verticalAlign="middle"
        >
          {cash}
        </Text>
      </Box>
    </Pressable>
  );
}

export default CashBalanceHeaderItem;
